import { createInitializer } from '../../utilities/initializer';
import { MocksState } from './mocks-state';

export interface MocksStore {
    mocksState: MocksState;
}

export const MocksStore = createInitializer<MocksStore>({ mocksState: MocksState.NotConfigured });
